import { Collapse } from "@mui/material";
import Fade from "@mui/material/Fade";
import React, { FC } from "react";
import { SideMenuLeftIcon } from "shared/theme/icons/SideMenuLeftIcon";
import { SideMenuRightIcon } from "shared/theme/icons/SideMenuRightIcon";
import { RollinLogo } from "shared/theme/logo/RollinLogo";
import { RollinSmallLogo } from "shared/theme/logo/RollinSmallLogo";
import { StyledButton, StyledHeader } from "./styled";

export type HeaderProps = Partial<{
  icon?: {
    source: React.ReactNode;
    bgColor?: string;
  };
  title: string;
  titleColor?: string;
  subtitle?: string;
  isMenuBarExpanded: boolean;
  isHovered: boolean;
  toggleMenuBar: () => void;
}>;

const Header: FC<HeaderProps> = (props) => (
  <StyledHeader shouldCenter={!(props.isMenuBarExpanded || props.isHovered)}>
    <Fade in={props.isMenuBarExpanded} timeout={1000}>
      <div style={{ display: props.isMenuBarExpanded ? "block" : "none" }}>
        <RollinLogo />
      </div>
    </Fade>
    <Fade in={!props.isMenuBarExpanded} timeout={1000}>
      <div style={{ display: !props.isMenuBarExpanded ? "block" : "none" }}>
        <RollinSmallLogo />
      </div>
    </Fade>
    <Collapse
      in={props.isMenuBarExpanded || props.isHovered}
      timeout={300}
      unmountOnExit
      orientation="horizontal"
    >
      <StyledButton onClick={props.toggleMenuBar}>
        {props.isMenuBarExpanded ? <SideMenuLeftIcon /> : <SideMenuRightIcon />}
      </StyledButton>
    </Collapse>
  </StyledHeader>
);

export default Header;
